const loggin_on = true;

export default function log(v) {
  // temporary log function;
  // turn off with the const above
  if (loggin_on) {
    console.log('[ INFO ] - ' + v);
  }
}
